/** Espelha ServiceInterfacePlatformCatalog do backend para opções de filtro. */
export type ServiceInterfaceCatalogDefinition = {
  serviceKey: string;
  description: string;
  platformName: string;
};

const CATALOG: Record<string, Array<{ serviceKey: string; description: string }>> = {
  WHATSAPP: [
    { serviceKey: "T2B_WHATSAPP", description: "Sincronização de mensagens T2B -> Whatsapp" },
    { serviceKey: "T2B_WHATSAPP_CAMPAIGN", description: "Sincronização de campanhas T2B -> Whatsapp" },
    { serviceKey: "T2B_WHATSAPP_TEMPLATE", description: "Sincronização de templates T2B -> Whatsapp" },
    {
      serviceKey: "T2B_WHATSAPP_CAMPAIGN_FINALIZER",
      description: "Finaliza campanhas após período de vigência",
    },
  ],
  GUPSHUP: [
    { serviceKey: "WHATSAPP_BSP_T2B", description: "Sincronização de mensagens Whatsapp BSP -> T2B" },
    { serviceKey: "T2B_WHATSAPP_BSP", description: "Sincronização de mensagens T2B -> Whatsapp" },
    { serviceKey: "T2B_WHATSAPP_BSP_TEMPLATE", description: "Sincronização de templates T2B -> Whatsapp" },
    { serviceKey: "T2B_WHATSAPP_BSP_CAMPAIGN", description: "Sincronização de campanhas T2B -> Whatsapp" },
    {
      serviceKey: "T2B_WHATSAPP_BSP_CAMPAIGN_FINALIZER",
      description: "Finaliza campanhas após período de vigência",
    },
  ],
  LOJAINTEGRADA: [
    { serviceKey: "LOJA_INTEGRADA_ORDER", description: "Sincronização de pedidos Loja Integrada -> T2B" },
  ],
  TRAY: [
    { serviceKey: "TRAY_ORDER", description: "Sincronização de pedidos Tray -> T2B" },
    { serviceKey: "TRAY_PRODUCT", description: "Sincronização de produtos Tray -> T2B" },
  ],
  ASAAS: [
    { serviceKey: "ASAAS_T2B", description: "Sincronização de pagamentos Asaas -> T2B" },
  ],
  WAKE: [
    { serviceKey: "WAKE_CATALOGSYNC", description: "Ativa sincronização do catálogo Wake" },
    { serviceKey: "WAKE_ORDERSYNC", description: "Ativa sincronização de pedidos Wake" },
    { serviceKey: "WAKE_STATUSSYNC", description: "Ativa sincronização de status de pedido Wake" },
  ],
  KPL: [
    { serviceKey: "KPL_ORDERSYNCOUTBOUND", description: "Sincronização de pedidos KPL -> T2B" },
    { serviceKey: "KPL_ORDERSTATUSSYNCOUTBOUND", description: "Sincronização de status de pedidos KPL -> T2B" },
    {
      serviceKey: "KPL_ORDERSTATUSSYNCINBOUND",
      description: "Sincronização de status de pedidos KPL (inbound)",
    },
  ],
  FRENET: [
    { serviceKey: "FRENET_FREIGHT_QUOTE", description: "Monitoramento da cotação de frete Frenet" },
  ],
};

const PLATFORM_CATALOG_ALIASES: Record<string, string> = {
  WHATSAPP: "WHATSAPP",
  WHATSAPP_BSP: "GUPSHUP",
  GUPSHUP: "GUPSHUP",
  LOJAINTEGRADA: "LOJAINTEGRADA",
  "LOJA INTEGRADA": "LOJAINTEGRADA",
  TRAY: "TRAY",
  "TRAY COMMERCE": "TRAY",
  TRAYCOMMERCE: "TRAY",
  ASAAS: "ASAAS",
  WAKE: "WAKE",
  KPL: "KPL",
  FRENET: "FRENET",
};

export function resolveServiceInterfacePlatformKey(platformName: string): string | null {
  const upper = platformName.trim().toUpperCase();
  const compact = upper.replace(/\s+/g, "");

  if (PLATFORM_CATALOG_ALIASES[upper]) return PLATFORM_CATALOG_ALIASES[upper];
  if (PLATFORM_CATALOG_ALIASES[compact]) return PLATFORM_CATALOG_ALIASES[compact];
  if (upper in CATALOG) return upper;
  if (compact in CATALOG) return compact;

  return null;
}

export function isServiceInterfacePlatform(platformName: string): boolean {
  return resolveServiceInterfacePlatformKey(platformName) !== null;
}

export function getCatalogServicesForPlatforms(
  platformNames: string[]
): ServiceInterfaceCatalogDefinition[] {
  const map = new Map<string, ServiceInterfaceCatalogDefinition>();

  for (const rawName of platformNames) {
    const platformName = resolveServiceInterfacePlatformKey(rawName);
    if (!platformName) continue;

    const entries = CATALOG[platformName] ?? [];

    for (const entry of entries) {
      if (!map.has(entry.serviceKey)) {
        map.set(entry.serviceKey, { ...entry, platformName });
      }
    }
  }

  return Array.from(map.values()).sort((a, b) => a.serviceKey.localeCompare(b.serviceKey));
}
